// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false
Vue.use(VueScrollTo, {
  container: 'body', // スクロールするcontainer
  duration: 500, // スクロールアニメーションの長さ（ミリ秒）
  easing: 'ease', // 使用されるイージング
  force: true, // スクロールターゲットがすでに表示されている場合でも、スクロールを実行するかどうか。
  cancelable: false // ユーザーがスクロールをキャンセルできるかどうか
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js